// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__396OM","inputWrap":"CustomTip_inputWrap__2fAhw"};